module.exports = __webpack_public_path__ + "img/female_A_02.ba326d02.png";